import { render, staticRenderFns } from "./profile.vue?vue&type=template&id=f15afe08&scoped=true&"
import script from "./profile.vue?vue&type=script&lang=js&"
export * from "./profile.vue?vue&type=script&lang=js&"
import style0 from "./profile.vue?vue&type=style&index=0&id=f15afe08&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f15afe08",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/corp-dev.1clicom.ru/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f15afe08')) {
      api.createRecord('f15afe08', component.options)
    } else {
      api.reload('f15afe08', component.options)
    }
    module.hot.accept("./profile.vue?vue&type=template&id=f15afe08&scoped=true&", function () {
      api.rerender('f15afe08', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/profile/profile.vue"
export default component.exports